import { useEffect } from 'react'

import type { ExcludeArea, SubArea } from '@ai-color-modules/simulation/types'

interface UseLayerEditingStateSyncOptions {
  activeTab: string
  openLayerId: string | null
  setOpenLayerId: React.Dispatch<React.SetStateAction<string | null>>
  editingArea: string | null
  setEditingArea: React.Dispatch<React.SetStateAction<string | null>>
  subAreas: SubArea[]
  excludeAreas: ExcludeArea[]
}

export const useLayerEditingStateSync = ({
  activeTab,
  openLayerId,
  setOpenLayerId,
  editingArea,
  setEditingArea,
  subAreas,
  excludeAreas,
}: UseLayerEditingStateSyncOptions) => {
  useEffect(() => {
    setOpenLayerId(null)
    setEditingArea(null)
  }, [activeTab, setEditingArea, setOpenLayerId])

  useEffect(() => {
    if (openLayerId === null || openLayerId.startsWith('exclude-')) {
      setEditingArea(null)
    }
  }, [openLayerId, setEditingArea])

  useEffect(() => {
    if (!openLayerId) {
      return
    }

    if (openLayerId.startsWith('custom-')) {
      const index = Number.parseInt(openLayerId.replace('custom-', ''), 10)
      if (!subAreas[index]) {
        setOpenLayerId(null)
      }
      return
    }

    if (openLayerId.startsWith('exclude-')) {
      const index = Number.parseInt(openLayerId.replace('exclude-', ''), 10)
      if (!excludeAreas[index]) {
        setOpenLayerId(null)
      }
    }
  }, [excludeAreas, openLayerId, setOpenLayerId, subAreas])

  useEffect(() => {
    if (!editingArea?.startsWith('subarea-')) {
      return
    }

    const index = Number.parseInt(editingArea.replace('subarea-', ''), 10)
    if (!subAreas[index]) {
      setEditingArea(null)
    }
  }, [editingArea, setEditingArea, subAreas])
}
